import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * ProtectedRoute 컴포넌트
 * 인증된 사용자만 접근 가능한 라우트 보호
 */
const ProtectedRoute = ({ children }) => {
  // localStorage에서 토큰 확인
  const token = localStorage.getItem('adminToken');

  // 토큰이 없으면 로그인 페이지로 리다이렉트
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }

  // Mock 토큰 검증
  try {
    const decoded = JSON.parse(atob(token));
    const currentTime = Date.now();

    // 토큰이 24시간 이상 경과했으면 만료로 간주
    if (currentTime - decoded.timestamp > 24 * 60 * 60 * 1000) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
      return <Navigate to="/admin/login" replace />;
    }
  } catch (error) {
    // 토큰 검증 실패
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    return <Navigate to="/admin/login" replace />;
  }

  // 인증 성공 - 자식 컴포넌트 렌더링
  return children;
};

export default ProtectedRoute;
